<form class=" w-100 h-100 form" [formGroup]="bannerForm" (ngSubmit)="sendData()">
  <h4 class="text-center">Nuevo Banner</h4>
  <div class="row mx-0 my-3 p-0 ">
    <div class="col-12 pl-xl-0 mt-2 mb-4">
      <div class="vs-outline-editCard btn-custom-banner">
        <img class="given-img mb-4" [src]="fileImg64 | safeDom" alt="img-banner" *ngIf="fileImg64">
        <div class="btn-custom-file w-100">
          <label for="file-upload-logo" class="custom-file-upload h-fit-content p-3">
            <mat-icon>{{!fileImg64 ? 'image': '' }} </mat-icon>
            <span class="my-2" *ngIf="!wrongSize">
              Elegir imagen Desktop de 1440px x 120px
            </span>
            <span class="my-2 text-danger" *ngIf="wrongSize">{{wrongSize}}</span>
          </label>
          <input id="file-upload-logo" type="file" accept="image/*" (change)="getBase64($event,'img1','img641',1)" />
        </div>
      </div>
    </div>
    <div class="col-6 pl-xl-0 mt-2 mb-4">
      <div class="vs-outline-editCard btn-custom-banner">
        <img class="given-img mb-4" [src]="fileImg642 | safeDom" alt="img-banner" *ngIf="fileImg642">
        <div class="btn-custom-file w-100">
          <label for="file-upload-logo2" class="custom-file-upload h-fit-content p-3">
            <mat-icon>{{!fileImg642 ? 'image': '' }} </mat-icon>
            <span class="my-2" *ngIf="!wrongSize2">
              Elegir imagen Mobile de 822px x 272px
            </span>
            <span class="my-2 text-danger" *ngIf="wrongSize2">{{wrongSize2}}</span>
          </label>
          <input id="file-upload-logo2" type="file" accept="image/*" (change)="getBase64($event,'img2','img642',2)" />
        </div>
      </div>
    </div>
    <div class="col-6 pl-xl-0 mt-2 mb-4">
      <div class="vs-outline-editCard btn-custom-banner">
        <img class="given-img mb-4" [src]="fileImg643 | safeDom" alt="img-banner" *ngIf="fileImg643">
        <div class="btn-custom-file w-100">
          <label for="file-upload-logo3" class="custom-file-upload h-fit-content p-3">
            <mat-icon>{{!fileImg643 ? 'image': '' }} </mat-icon>
            <span class="my-2" *ngIf="!wrongSize3">
              Elegir imagen Modal de 600px x 700px
            </span>
            <span class="my-2 text-danger" *ngIf="wrongSize3">{{wrongSize3}}</span>
          </label>
          <input id="file-upload-logo3" type="file" accept="image/*" (change)="getBase64($event,'img3','img643',3)" />
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Título</mat-label>
        <input matInput placeholder="Título" formControlName="title" required>
        <mat-error>Este campo es <b>Requerido</b></mat-error>
      </mat-form-field>
    </div>
    </div>
    <div class="col-6">
      <!-- <mat-form-field appearance="outline" class="w-100"> -->
        <!-- <mat-label>¿Por defecto?</mat-label> -->
        <div>
          <h5 class="m-0 font-weight-bold">¿Por defecto?</h5>
        </div>
        <mat-button-toggle-group #defaultExist="matButtonToggleGroup" (click)="changeDefault(defaultExist.value)"
          [value]="bannerForm.value.isDefault == true ? 'yes' : 'no'">
          <mat-button-toggle value="yes" aria-label="yes">
            <mat-icon style="color: green">check</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="no" aria-label="no" >
            <mat-icon style="color: red">cancel</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
        <input hidden matInput placeholder="Defecto" formControlName="isDefault" >
      <!-- </mat-form-field> -->
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Fecha de inicio</mat-label>
        <input id="pickerStart" matInput [matDatepicker]="pickerStart" formControlName="dateFrom">
        <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Fecha de fin</mat-label>
        <input id="pickerEnd" matInput [matDatepicker]="pickerEnd" formControlName="dateTo">
        <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>
      <mat-error *ngIf="convertDate(bannerForm.value.dateTo) < convertDate(bannerForm.value.dateFrom)" style="margin-top: -1rem">
        La fecha seleccionada es menor a la fecha de inicio
      </mat-error>
    </div>
  </div>
  <div class="bottom-button">
    <button class="vs-btn-blue" type="submit" [disabled]="bannerForm.invalid">
      Guardar
    </button>
  </div>
</form>